@if (readonly()) {
  <span>{{ readonlyValue() || ngControl.control.value || "-" }}</span>
} @else if (ngControl.control != null) {
  <input
    pInputText
    [autocomplete]="autocomplete"
    [placeholder]="placeholder"
    [name]="name"
    [formControl]="ngControl.control! | abstractControlToFormControl" />
}
